import React, { useState } from 'react';

import PurchaseOrderTable from '../../components/vendor-login/ordersComponent/purchaseOrder/purchaseOrderTable'


function PurchaseOrder(props) {
    const [searchValue, setSearchValue] = useState('')

    const handleSearch = (e, data) => {
        if(e.key == 'Enter'){
        setSearchValue(e.target.value)
        }
    }
    
    return (
        <React.Fragment>
            <div className="ag=theme-material agOver">
                <PurchaseOrderTable handleSearch={handleSearch} searchValue={searchValue} {...props} />
            </div>
        </React.Fragment>
    )
}


export default PurchaseOrder